export const reports = {
  description: "Operational and financial reports with date filters and CSV export.",
  downloadCsv: "Download CSV",
  report: "Report",
  noRows: "No rows",
  noRowsDesc: "Adjust the date range or create records to see results.",
  defs: {
    quoteConversion: "Quote conversion",
    jobStatus: "Job status & late work",
    wip: "WIP by work centre",
    stockReorder: "Stock & reorder",
    openPos: "Open purchase orders",
    actualVsEstimate: "Actual vs estimate",
    invoiceAging: "Invoice aging",
    cashActivity: "Cash activity",
  },
};
